module.exports = __webpack_public_path__ + "img/trrafic-exciting-icon.2d72752a.svg";